/** @jsxImportSource @emotion/react */
import tw from "twin.macro";

export const FeedbackNotationContainer = ({ children }) => {
  return (
    <div tw="flex gap-x-3 my-auto bg-gray-100 rounded-full py-1 px-2 height[min-content]">
      {children}
    </div>
  );
};

export const FeedbackNotation = ({ notation, clickCallback, selectedNotation, ...props }) => {
  const bgColors = {
    red: tw`bg-red-500 hover:bg-red-400 `,
    orange: tw`bg-yellow-500 hover:bg-yellow-400`,
    green: tw`bg-green-600 hover:bg-green-500`,
  };

  const shadow = "0 0 6px 1px";
  const shadowColors = {
    red: `${shadow} rgba(239, 68, 68, 0.6)`, // rouge clair
    orange: `${shadow} rgba(253, 224, 71, 0.7)`, // jaune clair
    green: `${shadow} rgba(34, 197, 94, 0.7)`, // vert clair
  };

  const isSelected = selectedNotation === notation;

  return (
    <div
      tw="h-5 w-5 rounded-full cursor-pointer relative transition-all duration-200 my-auto"
      onClick={() => {
        if (clickCallback) {
          clickCallback(notation);
        }
      }}
      css={[
        bgColors[notation],
        tw`bg-opacity-40`,
        selectedNotation === notation && [
          tw`bg-opacity-100`,
          { boxShadow: shadowColors[notation] },
        ],
      ]}
      {...props}
    >
      {/* Reflet */}
      {isSelected && (
        <div
          tw="absolute top-0.5 left-0.5 w-2/5 h-2/5 rounded-full pointer-events-none"
          css={{
            background:
              "radial-gradient(circle at 30% 30%, rgba(255,255,255,0.4), transparent 70%)",
          }}
        ></div>
      )}
    </div>
  );
};
